import { render, staticRenderFns } from "./CallRecording.vue?vue&type=template&id=2593120c&scoped=true"
import script from "./CallRecording.vue?vue&type=script&lang=js"
export * from "./CallRecording.vue?vue&type=script&lang=js"
import style0 from "./CallRecording.vue?vue&type=style&index=0&id=2593120c&prod&scoped=true&lang=css"
import style1 from "./CallRecording.vue?vue&type=style&index=1&id=2593120c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593120c",
  null
  
)

export default component.exports